/** @jsxRuntime classic */
/** @jsx jsx */
// eslint-disable-next-line no-restricted-imports
import { css, jsx } from "@emotion/core";
import * as React from "react";
import { Theme, TrashIcon } from "@ice/components";
import SingleColorChooser from "./SingleColorChooser";
import { Fragment } from "react";


/*
	Set of single color choosers - represents interactive color palette as
	a row of colors.
 */

interface ColorChooserSetProps {
	colors: string[];
	isHighlightable?: boolean;
	prefixElement?: any;
	onSelect?: (colors: string[]) => void;
	reverse?: boolean;
	onDelete?: () => void;
}


interface ColorChooserSetState {
	colors: string[];
	isHighlighted: boolean;
}


class ColorChooserSet extends React.Component<ColorChooserSetProps, ColorChooserSetState> {
	constructor(props: ColorChooserSetProps) {
		super(props);
		this.state = {
			colors: this.props.colors ? [...this.props.colors] : null,
			isHighlighted: false
		};
	}

	private highlight = (b: boolean) => {
		this.setState({isHighlighted: b});
	}

	render() {
		let colorsArr = this.state.colors ? [...this.state.colors] : null;
		if (colorsArr && this.props.reverse) {
			colorsArr = colorsArr.reverse();
		}
		const row = colorsArr ? colorsArr.map((c) => <SingleColorChooser color={c} onSelect={null} />) : null;

		if (row) {
			return (
				<div
					key={`colchset_${this.props.reverse}`}
					onMouseEnter={() => this.highlight(true)}
					onMouseLeave={() => this.highlight(false)}
					onClick={() => colorsArr && this.props.onSelect && this.props.onSelect(colorsArr)}
					css={(theme: Theme) => css`
						display: flex;
						flex-direction: row;
						align-items: center;
						padding: 0.4rem 0;
						background-color: ${this.props.isHighlightable && this.state.isHighlighted ? theme.listItem.selected.backgroundColor : "rgba(0, 0, 0, 0)"};
						cursor: pointer;
					`}
				>
					{this.props.prefixElement}
					{row}
					{this.props.onDelete && (
						<Fragment>
							<div style={{flexGrow: 1}} />
							<TrashIcon
								onClick={(e) => {
									e.stopPropagation();
									this.props.onDelete();
								}}
							/>
						</Fragment>
					)}
				</div>
			);
		}

		return null;
	}
}


export default ColorChooserSet;
